import { Component, OnInit, Inject } from "@angular/core";
import { MedicalAppointmentProcedure } from "../../../model/medical-appointment-procedure";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FilterService } from "src/app/services/filter.service";

@Component({
  selector: "app-billing-orden-control-procedure-affected-dialog",
  templateUrl:
    "./billing-orden-control-procedure-affected-dialog.component.html",
  styleUrls: [
    "./billing-orden-control-procedure-affected-dialog.component.css",
  ],
})
export class BillingOrdenControlProcedureAffectedDialogComponent
  implements OnInit
{
  procedures: MedicalAppointmentProcedure[];
  allSelected?: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<BillingOrdenControlProcedureAffectedDialogComponent>,
    private filterService: FilterService,
    @Inject(MAT_DIALOG_DATA) public data: MedicalAppointmentProcedure[]
  ) {
    this.procedures = data;
  }

  ngOnInit() {}

  getName(medicalAppointmentProcedure: MedicalAppointmentProcedure) {
    if (medicalAppointmentProcedure.SetSupplieName) {
      return medicalAppointmentProcedure.SetSupplieName;
    } else if (medicalAppointmentProcedure.PracticeRegionAditionalName) {
      return medicalAppointmentProcedure.PracticeRegionAditionalName;
    } else {
      return medicalAppointmentProcedure.PracticeRegionName;
    }
  }

  checkSelectAllChange(event: any) {
    this.procedures.forEach((p) => (p.ChangeBillingState = event.checked));
  }

  onNoClick() {
    this.dialogRef.close();
  }

  save() {
    if (this.procedures.findIndex((p) => p.ChangeBillingState === true) > -1) {
      this.dialogRef.close(true);
    }
  }
}
